import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "profile" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "white__navbar" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Данные профиля")
], -1)
const _hoisted_3 = { class: "profile__info" }
const _hoisted_4 = { class: "profile__info__data" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Имя пользователя", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "E-mail", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, "Название организации", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", null, "Пароль", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", null, "Телефон", -1)
const _hoisted_10 = { for: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_switch = _resolveComponent("v-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.client.client_avatar!='')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "profile__info__photo",
            style: _normalizeStyle(
                    'background-image: url(\'https://api.rekprof.ru/files/' +
                    _ctx.client.client_avatar +
                    '\')'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs.avatar_file.click()))
          }, null, 4))
        : _createCommentVNode("", true),
      (_ctx.client.client_avatar=='')
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "profile__info__photo",
            style: _normalizeStyle(
                    'background-image: url(\'https://api.rekprof.ru/files/blank/avatar.png\')'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$refs.avatar_file.click()))
          }, null, 4))
        : _createCommentVNode("", true),
      _createElementVNode("input", {
        ref: "avatar_file",
        type: "file",
        hidden: "",
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitFile('avatar_file')))
      }, null, 544),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.client.client_name) = $event))
          }, null, 512), [
            [_vModelText, _ctx.client.client_name]
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            type: "email",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.client.client_email) = $event))
          }, null, 512), [
            [_vModelText, _ctx.client.client_email]
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.client.client_company_name) = $event))
          }, null, 512), [
            [_vModelText, _ctx.client.client_company_name]
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            type: "password",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.client.client_pwd) = $event))
          }, null, 512), [
            [_vModelText, _ctx.client.client_pwd]
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            type: "number",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.client.client_phone) = $event))
          }, null, 512), [
            [_vModelText, _ctx.client.client_phone]
          ])
        ])
      ]),
      _createElementVNode("section", null, [
        _createElementVNode("label", _hoisted_10, [
          _createVNode(_component_v_switch, {
            style: {"display":"flex","flex-direction":"row","justify-content":"flex-start"},
            color: "#2F80ED",
            modelValue: _ctx.client.unstep,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.client.unstep) = $event)),
            label: "Предупреждения о незаполненных шагах",
            inline: ""
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("button", {
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.save_client()))
      }, "Сохранить")
    ])
  ]))
}